import * as _ from 'lodash';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import {
    Component,
    Input,
    ElementRef,
    Output,
    EventEmitter,
    ViewChild,
    HostListener,
    AfterContentInit
} from '@angular/core';

@Component({
    selector: 'fc-search-dropdown',
    templateUrl: './fc-search-dropdown.component.html',
    styleUrls: ['./fc-search-dropdown.component.less'],
    standalone: false
})
export class FcSearchDropdownComponent implements AfterContentInit {
    @Input() items: MultiRowItem[];
    @Input() placeholder = '';
    @Input() notFoundText = '';
    @Input() selectedItem: MultiRowItem;
    @Input() disabled = false;
    @Input() e2eHook: string;

    @Output() onSelect = new EventEmitter<MultiRowItem>();

    @ViewChild('input', { static: true }) private input: ElementRef;

    public itemsToDisplay: Observable<MultiRowItem[]>;
    public displayItems = false;

    constructor(private element: ElementRef) {}

    ngAfterContentInit() {
        const input$: Observable<string> = fromEvent(this.input.nativeElement, 'input').pipe(
            map((event: any) => event.target.value),
            debounceTime(500),
            distinctUntilChanged()
        );

        this.itemsToDisplay = input$.pipe(
            tap((query) => (this.displayItems = query.length > 2)),
            map((query) =>
                query.length > 2
                    ? _.filter(this.items, (item) =>
                          _.includes(_.join(_.map(item.textRows, this.deburr)), this.deburr(query))
                      )
                    : []
            )
        );
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: HTMLElement): void {
        if (this.element.nativeElement.contains(targetElement)) {
            return;
        }
        this.displayItems = false;
    }

    public selectItem(item: MultiRowItem) {
        this.input.nativeElement.value = '';
        this.displayItems = false;
        this.onSelect.emit(item);
    }

    public isSelected(item: MultiRowItem): boolean {
        if (this.selectedItem) {
            return _.isEqual(this.selectedItem, item);
        }
    }

    private deburr(text: string): string {
        return _.deburr(_.toLower(text));
    }
}

interface MultiRowItem<T = any> {
    textRows: string[];
    unavailable?: boolean;
    value: T;
}
